import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVkAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M15.744 13.53a5.5 5.5 0 0 0-.978-.837 7.87 7.87 0 0 0 2.859-4.471 1 1 0 1 0-1.95-.444 5.86 5.86 0 0 1-3.02 3.903V8.002a1 1 0 0 0-.044-.216 1 1 0 0 0-.035-.171 1 1 0 0 0-.167-.25c-.018-.02-.027-.048-.046-.068a1 1 0 0 0-.246-.167c-.026-.014-.045-.037-.072-.048a1 1 0 0 0-.236-.049 1 1 0 0 0-.152-.031L11.003 7H11a.995.995 0 0 0-.35 1.929v4.89a11.3 11.3 0 0 1-3.01-5.984 1 1 0 1 0-1.972.334 13.33 13.33 0 0 0 5.4 8.644 1 1 0 0 0 .128.064 1 1 0 0 0 .108.054 1 1 0 0 0 .35.071 1 1 0 0 0 .424-.102c.01-.005.021-.002.031-.007a1 1 0 0 0 .24-.176c.015-.014.024-.03.038-.045a1 1 0 0 0 .16-.237 1 1 0 0 0 .037-.087 1 1 0 0 0 .07-.346v-2.126a3.55 3.55 0 0 1 1.616 1.005l1.647 1.797a1 1 0 1 0 1.474-1.352ZM15.073 1H8.938C2.78 1 1 2.778 1 8.927v6.136C1 21.22 2.778 23 8.927 23h6.136C21.22 23 23 21.222 23 15.073V8.938C23 2.78 21.222 1 15.073 1M21 15.073c0 5.04-.888 5.927-5.937 5.927H8.927C3.887 21 3 20.112 3 15.063V8.927C3 3.887 3.888 3 8.938 3h6.135C20.113 3 21 3.888 21 8.938Z" />
  </svg>
);
export default SvgVkAlt;
